const HOST = "https://strapi.lexis.com.ec";
const images = [
  "/uploads/corte_constitucional_a7b0a3028c.png",
  "/uploads/aws_6566b4f63d.png",
  "/uploads/google_fe85d9d298.png",
  "/uploads/lexinteramericana_fd10bc2a0b.png",
  "/uploads/microsoft_azure_2f409660ae.png",
  "/uploads/open_ia_6d810d21f0.png",
  "/uploads/Claude_1b5989bed1.png",
  "/uploads/conturbo_f2db72be05.png",
  "/uploads/citec_5b53e80f14.png",
  "/uploads/eela_education_c77fe9bb16.png",
  "/uploads/usfq_law_review_ef4f0fc61b.png",
  "/uploads/lex_lab_e59bb8f6b4.png",
  "/uploads/el_instituto_b9af1cf0f6.png"
];

export default function CarruselInstituciones() {
  // Duplicamos para un loop sin cortes
  const track = [...images, ...images];

  return (
    <section className="py-10 mt-20">
      <div className="mx-auto">
        
        <div className="relative mt-8 overflow-hidden">
          {/* Carrusel */}
          <div className="group">
            <ul className="marquee flex gap-10 items-center will-change-transform">
              {track.map((src, i) => (
                <li key={i} className="shrink-0">
                  <img
                    src={`${HOST}${src}`}
                    alt="Institución"
                    className="h-10 sm:h-12 md:h-14 w-auto object-contain opacity-80 grayscale
                               transition duration-300 group-hover:opacity-100 hover:grayscale-0"
                    loading="lazy"
                    decoding="async"
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Estilos propios (solo esta sección) */}
      <style>{`
        /* Duración más rápida en pantallas grandes */
        @media (min-width: 1024px) {
          .marquee { animation: scroll 25s linear infinite; }
        }
        @media (max-width: 1023.98px) {
          .marquee { animation: scroll 35s linear infinite; }
        }
        /* Pausa al hacer hover sobre el contenedor */
        .group:hover .marquee { animation-play-state: paused; }

        /* Truco de loop: al tener el track duplicado, desplazamos el 50% exacto */
        @keyframes scroll {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
